export default __webpack_public_path__ + "static/media/marker_point_blue.a661ee91.svg";